import React from 'react';
import {
  QuestionOperationsContext,
  type QuestionOperationsContextType,
} from './questionOperationsContext';

export const QuestionOperationsProvider: React.FC<{
  children: React.ReactNode;
  value: QuestionOperationsContextType;
}> = ({ children, value }) => {
  return (
    <QuestionOperationsContext.Provider value={value}>
      {children}
    </QuestionOperationsContext.Provider>
  );
};
